<app-ark-container
  [future]="dataObservable"
  [titleTemplate]="title"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onGridDataResolved($event[0])"
  (onFailure)="onFailure($event[0])"
>
</app-ark-container>

<ng-template #title>
  <div nz-row class="monitor-header">
    <div nz-col nzSpan="10" class="monitor-heading header-2">
      Line Item Monitor
    </div>
    <div nz-col nzSpan="14" class="btn-holder">
      <div *ngIf="showRevisionSelectBox" class="revision-dd-holder">
        <!-- [(ngModel)]="revisionStart"
        (ngModelChange)="onRevisionStartChange()" -->
        <nz-select
          [(ngModel)]="revisionStart"
          nzSize="small"
          [nzDropdownClassName]="'lim-revision-select'"
          style="width: 150px"
          [nzCustomTemplate]="customRevisionSelect"
        >
          <nz-option
            nzCustomContent
            *ngFor="let option of revisionOptions"
            [nzLabel]="option.label"
            [nzValue]="option.value"
          >
            <div class="selected-option">
              <va-icon
                *ngIf="revisionStart === option.value"
                size="small"
                name="check"
                class="mt-4"
              ></va-icon>
            </div>
            {{ option.label }}
          </nz-option>
        </nz-select>
      </div>

      <div class="button-container">
        <button
          nz-button
          nzType="primary"
          nzSize="small"
          [nzLoading]="editModalLoading"
          *ngIf="
            (!hasError && !isInactiveCompany && !isModelsOnlyUser) ||
            this.isNoLineSelected
          "
          (click)="createModal()"
        >
          Customize Line Items
        </button>
      </div>
      <div
        class="lim-alert"
        *ngIf="isLimEnabled"
        nz-tooltip
        [nzTooltipPlacement]="'top'"
        nzTooltipTitle="Receive alert emails when consensus of line items in your monitor were revised over your chosen threshold."
        nzTooltipTrigger="hover"
      >
        <va-icon
          [isFontAwesome]="true"
          class="alert-icon"
          small="small"
          [name]="faBell"
          nz-popover
          nzPopoverTitle="Line Item Delta Alert"
          [(nzPopoverVisible)]="visibleAlerts"
          nzPopoverTrigger="click"
          nzPopoverPlacement="right"
          nzPopoverOverlayClassName="lid-alerts-popover-overlay"
          [nzPopoverContent]="alertsTemplate"
        ></va-icon>
      </div>
      <div>
        <a
          *ngIf="!hasError && !isInactiveCompany && !isModelsOnlyUser"
          nz-tooltip
          [nzTooltipPlacement]="'top'"
          nzTooltipTitle="Export"
          nzTooltipTrigger="hover"
          nz-dropdown
          [nzDropdownMenu]="menu"
          nzTrigger="click"
          nzBackdrop="false"
          nzPlacement="bottomRight"
          class="lim-excel"
        >
          <va-icon
            [isFontAwesome]="true"
            [name]="faFileExcel"
            class="lim-excel-icon"
          ></va-icon>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="exportToExcel(1)">Values</li>
            <li nz-menu-item (click)="exportToExcel(0)">
              Excel Add-In Formulas
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customRevisionSelect let-selected>
  <span>Baseline: {{ selected.nzLabel }}</span>
</ng-template>

<ng-template #success>
  <div *ngIf="hasError || isNoLineSelected" class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
  <nz-tabset
    [nzType]="'card'"
    nzAnimated="false"
    *ngIf="!hasError && !isNoLineSelected"
    (nzSelectedIndexChange)="onTabChange($event)"
  >
    <nz-tab nzTitle="Trend">
      <ng-template nz-tab>
        <app-trend-lim
          *ngIf="lineItemsMeta"
          [ticker]="ticker"
          [lineItemsMeta]="lineItemsMeta"
          (updatePeriod)="onPeriodUpdation($event[0])"
        ></app-trend-lim>
      </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Dispersion">
      <ng-template nz-tab>
        <app-dispersion-lim
          *ngIf="lineItemsMeta"
          [ticker]="ticker"
          [lineItemsMeta]="lineItemsMeta"
          (updatePeriod)="onPeriodUpdation($event[0])"
        ></app-dispersion-lim>
      </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Revision">
      <ng-template nz-tab>
        <app-revision-lim
          *ngIf="lineItemsMeta"
          [ticker]="ticker"
          [lineItemsMeta]="lineItemsMeta"
          [revisionStart]="revisionStart"
          (updatePeriod)="onPeriodUpdation($event[0])"
        ></app-revision-lim>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</ng-template>

<ng-template #loading>
  <!-- 
  Don't show loader by default  
  <ul nz-menu style="border: none">
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
      style="padding: 0px 15px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul> -->
</ng-template>

<ng-template #failure>
  <div class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text"
        >{{ errMsg }} Line Item Monitor could not be loaded.</span
      >
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
</ng-template>

<app-line-item-edit-modal
  *ngIf="showEditModal"
  [addColTableData]="addColTableData"
  [ticker]="ticker"
  max="100"
  maxHeight="250px"
  [stdLineItems]="stdLineItems"
  [isLIMModal]="true"
  (save)="saveLineItems($event)"
  (close)="closeEditModal()"
></app-line-item-edit-modal>

<ng-template #alertsTemplate>
  <app-lid-alert-popover
    (onSave)="closeAlert()"
    [ticker]="ticker"
  ></app-lid-alert-popover>
</ng-template>
